import defaultAttributes from '../defaultAttributes';

const Bookmark = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M19 21l-7-4-7 4V5a2 2 0 012-2h10a2 2 0 012 2v16z' }]],
];

export default Bookmark;
